import React, { useState, useEffect } from "react"

import { Button } from "reactstrap"
import PoweredByQuoli from "../PoweredByQuoli"
import { checkAccess, checkAccessed } from "../../../helper"

export default function NewThatsAll(props) {
  let {
    settings,
    errorAttribute,
    setFName,
    fName,
    lName,
    setLName,
    showDetail,
    email,
    setEmail,
    setAnswer,
    setRequiredAttributes,
    ordersData,
    orderProductIndex,
    isTyped,
    onContinueClick,
    isDisable,
    starCheck,
    starReview,
    data,
    attributes,
    setOrderProductIndex,
    onEditReviewClick,
    submitReview,
    setIsTyped1,
    setIsTyped2,
    setIsTyped3,
    isTyped1,
    isTyped2,
    isTyped3,
    orderNo,
    edit,
    setStarCheck,
    // New validation props
    titleError,
    setTitleError,
    descriptionError,
    setDescriptionError,
    isOnSite,
    collectSettings
  } = props
  console.log("🚀 ~ NewThatsAll ~ fName:", attributes, data?.attributes)
  const params = new URLSearchParams(window.location.search)
  const customerName = params.get("customerName")
  const customerEmail = params.get("customerEmail")
  let firstName = "";
  let lastName = "";

  if (customerName) {
    if (customerName.includes(" ")) {
      [firstName, lastName] = customerName.split(" ");
      setFName(firstName);
      setIsTyped1(firstName)
      setIsTyped2(lastName)
      setIsTyped3(customerEmail)
      setLName(lastName);
      setEmail(customerEmail)
    } else {
      setIsTyped1(customerName)
      setIsTyped3(customerEmail)
      setFName(customerName)
      setEmail(customerEmail)
    }
  }

  // const [fName, setFName] = useState("")

  const [allAttributes, setAllAttributes] = useState(false)
  console.log(allAttributes, "allAttributesallAttributes")

  const [error, setError] = useState({})

  const [isValid, setIsValid] = useState(true)

  const handleInputChange1 = (e) => {
    setIsTyped1(e.target.value !== "")
    setFName(e.target.value)
    setError({
      ...error,
      firstName: null,
    })
  }
  console.log("errorerror", error)
  const handleInputChange2 = (e) => {
    setIsTyped2(e.target.value !== "")
    setLName(e.target.value)
    setError({
      ...error,
      lastName: null,
    })
  }
  useEffect(() => {
    console.log("last name", lName)
  }, [lName])

  const handleInputChange3 = (e) => {
    setIsTyped3(e.target.value != "")
    console.log("emaail", e.target.value, isTyped3)
    const newEmail = e.target.value
    // Regular expression to validate email addresses
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/

    setIsValid(emailRegex.test(newEmail))
    console.log("submit123123123", newEmail)
    // if (isValid) {
    setEmail(newEmail)
    setError({
      ...error,
      email: null,
    })
    // onEmailChange(newEmail)
    // }
  }
  // let [submitReview, setSubmitReview] = useState(false)


  return (
    <div className="thats-all-container new-thats-all">
      <div
        className="thats-all-popup"
        style={{
          color: settings?.fontColor ?? "#000",
          "--rate-background": settings?.backgroundColor ?? "#fff",
        }}
      >
        <div className="popup-content new-popup-rcf">
          {showDetail ? (
            <p className="error-description" style={{ color: "red" }}>
              {allAttributes && "Please fill all required fields {*}"}
            </p>
          ) : (
            ""
          )}
          {showDetail ? (
            ""
          ) : (
            <div>
              <p className="required-fields-text text-start" style={{ color: allAttributes ? "red" : settings?.fontColor ?? "#000" }}>{allAttributes ? "Please select required fields. Required fields are marked with *" : "Required fields are marked with *"}</p>

              <hr style={{ marginBottom: "25px" }} />
              {/* Main heading */}
              <div
                className="rcf-rating-heading pb-3"
                style={{
                  color: settings?.fontColor ?? "#000",
                }}
              >
                Tell us about yourself  *
              </div>
              <div className="thats-all-inputs new-thats-all-rcf">
                <div className="input-feild-rcf-main-div pb-3 gap-3 mb-0">
                  <div className="input-field-main-div-rcf ">
                    <input
                      type="text"
                      id="first-name"
                      autoComplete={"off"}
                      className={`input-field-rcf-review ${error.firstName ? "error" : ""
                        }`}
                      placeholder="First name"
                      value={
                        orderNo
                          ? ordersData?.[0]?.customerName?.split(" ")?.[0]
                          : fName
                      }
                      onChange={handleInputChange1}
                      style={{ color: settings?.fontColor ?? "#000" }}
                      disabled={orderNo}
                    />
                    {/* <p className="error-description" style={{ color: "red" }}>
                      {error.firstName && "Select required field"}
                    </p> */}
                  </div>
                  <div className="input-field-main-div-rcf">
                    <input
                      type="text"
                      id="last-name"
                      autoComplete={"off"}
                      className={`input-field-rcf-review ${error.lastName ? "error" : ""
                        }`}
                      placeholder="Last name"
                      value={
                        orderNo
                          ? ordersData?.[0]?.customerName?.split(" ")?.[1]
                          : lName
                      }
                      onChange={handleInputChange2}
                      style={{ color: settings?.fontColor ?? "#000" }}
                      disabled={orderNo}
                    />
                    {/* <p className="error-description" style={{ color: "red" }}>
                      {error.lastName && "Select required field"}
                    </p> */}
                  </div>
                </div>
                <div className="email-input">
                  {/* <label
              htmlFor="email-input"
              className={isTyped3 ? "label-active" : "label"}
              >
              Email
              </label> */}
                  <input
                    type="email"
                    name=""
                    id="email"
                    autoComplete={"off"}
                    className={`input-field-rcf-review ${!isValid || error.email ? "error" : ""
                      }`}
                    placeholder="Email"
                    value={orderNo
                      ? ordersData?.[0]?.customerEmail
                      : email
                    }
                    onChange={handleInputChange3}
                    style={{ color: settings?.fontColor ?? "#000" }}
                    disabled={orderNo}
                  />

                  {isOnSite && collectSettings?.organizeNewReviews?.isOnsiteVerified && <p className="rcf-policy-term-tag" style={{ color: settings?.toolTipColor ?? "grey", padding: "3px" }}>We'll send you an email to verify this review came from you.</p>}
                  <p className="error-description" style={{ color: "red" }}>
                    {!isValid ? "Please enter valid email" : ""}
                  </p>
                </div>
              </div>
              {/* <p className="error-description" style={{ color: "red" }}>
                {allAttributes && "Select required field"}
              </p> */}

              {/* <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0px",
                  alignItems: "center",
                }}
              >
                <div>
                  <p
                    className="rcf-policy-term-tag pt-2"
                    style={{
                      color: settings?.toolTipColor ?? "grey",
                    }}
                  >
                    By continuing you agree to Quoli’s{" "}
                    <a
                      className="rcf-policy-term-tag"
                      href="https://quoli.io/terms-of-service/"
                      target="_blank"
                      style={{
                        color: settings?.toolTipColor ?? "grey ",
                      }}
                    >
                      Terms and Conditions
                    </a>{" "}
                    and{" "}
                    <a
                      className="rcf-policy-term-tag"
                      href="https://quoli.io/privacy-policy/"
                      target="_blank"
                      style={{
                        color: settings?.toolTipColor ?? "grey ",
                      }}
                    >
                      Privacy Policy.
                    </a>{" "}
                  </p>
                  <p
                    className="rcf-policy-term-tag"
                    style={{
                      color: settings?.toolTipColor ?? "grey",
                    }}
                  >
                    Your email won’t be shown publicly and we never share emails
                    with others.
                  </p>
                </div>
              </div> */}
            </div>
          )}
          <div className=" d-flex gap-2">
            {orderProductIndex !== ordersData[0]?.products.length ? (
              <div style={{ width: "100%" }} className="skip-next">
                <Button
                  className="rcf-skip-btn"
                  onClick={() => {
                    setOrderProductIndex((prevIndex) => prevIndex + 1)
                    window.scrollTo({ top: 0 })
                  }}
                >
                  Skip
                </Button>
              </div>
            ) : (
              ""
            )}

            <div
              style={{ width: "100%" }}
              className={`${true ? "skip-next" : ""}`}
            >
              <Button
                // disabled={isDisable}
                className={`rcf-submit-btn ${isTyped1 && isTyped2 && isTyped3 && isValid
                  ? "next-btn"
                  : "next-btn-dis"
                  } `}
                onClick={() => {
                  if (data.review === undefined || data.review < 1) {
                    setStarCheck(true)
                  }

                  // Validate title and description
                  const isTitleEmpty = !data?.title || data.title.trim() === ""
                  const isDescriptionEmpty = !data?.description || data.description.trim() === ""

                  setTitleError(isTitleEmpty)
                  setDescriptionError(isDescriptionEmpty)

                  setError({
                    ...error,
                    firstName: !Boolean(isTyped1) && !orderNo,
                    lastName: !Boolean(isTyped2) && !orderNo,
                    email: !Boolean(isTyped3) && !orderNo,
                  })
                  console.log(data.attributes, "asjdasdasss")
                  if (
                    data?.attributes === undefined ||
                    data.attributes.length === 0
                  ) {
                    console.log(data?.attributes, "akjshdakjsdhkajs")
                    setRequiredAttributes(true)
                  }
                  var areAllRequiredOptionsSelected = false
                  if (attributes) {

                    if (checkAccessed("attributeRatings") === true) {
                      areAllRequiredOptionsSelected = attributes
                        ?.filter((obj) => {
                          console.log("🚀 ~ NewThatsAll ~ obj:", obj)
                          return obj.required
                        })
                        .every((requiredObj) => {
                          console.log(
                            "🚀 ~ .every ~ requiredObj:",
                            requiredObj?._id
                          )
                          return data.attributes?.some((selected) => {
                            console.log("🚀 ~ .every ~ selected:", selected?._id)
                            return selected._id === requiredObj._id
                          })
                        })
                    } else {
                      areAllRequiredOptionsSelected = true
                    }
                  } else {
                    areAllRequiredOptionsSelected = true
                  }
                  // submitReview(true)
                  console.log(
                    areAllRequiredOptionsSelected,
                    attributes,
                    data.attributes,
                    "areAllRequiredOptionsSelected"
                  )
                  setAllAttributes(!areAllRequiredOptionsSelected)

                  // else if (areAllRequiredOptionsSelected) {
                  //   swiper.slideNext()
                  //   window.scrollTo({ top: 0 })
                  // }

                  // console.log("this is SetIsdisbale site", se)
                  console.log("Boolean(isTyped1)", Boolean(isTyped1))
                  console.log("Boolean(isTyped1)", Boolean(isTyped2))
                  console.log("Boolean(isTyped1)", Boolean(isTyped3))
                  console.log("Boolean(isTyped1)", isValid)
                  console.log("Boolean(isTyped1)", starCheck)
                  console.log("Boolean(isTyped1)", starReview)
                  console.log(
                    "Boolean(isTyped1)",
                    areAllRequiredOptionsSelected
                  )

                  if (
                    Boolean(isTyped1) &&
                    Boolean(isTyped2) &&
                    Boolean(isTyped3) &&
                    isValid &&
                    !starCheck &&
                    areAllRequiredOptionsSelected &&
                    !isTitleEmpty &&
                    !isDescriptionEmpty && !(data.review === undefined || data.review < 1)
                  ) {
                    edit
                      ? onEditReviewClick({
                        reviewerName: fName + " " + lName,
                        reviewerEmail: email,
                      })
                      : onContinueClick({
                        reviewerName: fName + " " + lName,
                        reviewerEmail: email,
                      })

                    setAnswer(3)
                    console.log(showDetail, "===>showdetail")
                    setOrderProductIndex((prevIndex) => prevIndex + 1)
                    // setShowLoaderSub(false)
                  } else {
                    setAllAttributes(true)
                  }
                }}
              >
                {edit
                  ? "Agree & Submit Review"
                  : orderProductIndex !== ordersData[0]?.products?.length
                    ? "Submit & Next"
                    : "Agree & Submit Review"}
              </Button>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0px",
              alignItems: "center",
            }}
          >
            <div>
              <p
                className="rcf-policy-term-tag pt-2"
                style={{
                  color: settings?.toolTipColor ?? "grey",
                }}
              >
                By continuing you agree to Quoli’s{" "}
                <a
                  className="rcf-policy-term-tag"
                  href="https://quoli.io/terms-of-service/"
                  target="_blank"
                  style={{
                    color: settings?.toolTipColor ?? "grey ",
                  }}
                >
                  Terms and Conditions
                </a>{" "}
                and{" "}
                <a
                  className="rcf-policy-term-tag"
                  href="https://quoli.io/privacy-policy/"
                  target="_blank"
                  style={{
                    color: settings?.toolTipColor ?? "grey ",
                  }}
                >
                  Privacy Policy.
                </a>{" "}
              </p>
            </div>
          </div>

          <PoweredByQuoli />
          {/* <div className="last-submit-heading-main-container">
            <span className="rcf-company-heading-powered">Powered by</span>
            <div className="quoli-logo-main-div">
              <img src={QuoliLogo} alt="QuoliLogo" />
              <span className="quoli-title-text-tag">Quoli</span>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  )
}
